export default __webpack_public_path__ + "static/girl-with-pug-square-3a949213824c9552653573a5885f8ad6.png";